import { render, staticRenderFns } from "./ProfileEventTypeRenderer.vue?vue&type=template&id=4c2b066b&"
import script from "./ProfileEventTypeRenderer.vue?vue&type=script&lang=js&"
export * from "./ProfileEventTypeRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports